import {
  useDebugValue,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';

import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

import { useAuth } from 'react-oidc-context';
import { Modal } from 'react-bootstrap';
import { Button, CircularProgress, Step, StepLabel, Stepper, styled, ToggleButton, ToggleButtonGroup, toggleButtonGroupClasses, Tooltip, Typography } from '@mui/material';

import {
  getStripePublishableKey,
} from '../../types/stripe';

const STRIPE_PUBLISHABLE_KEY = await getStripePublishableKey();

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    display: 'flex',
    flex: 1,
    width: '100%',
    margin: '0.6vw!important',
    border: 0,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'rgb(0, 0, 0, 0.03)',
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0,
    },
    [`&.${toggleButtonGroupClasses.selected}`]: {
      backgroundColor: 'rgb(255, 255, 255, 0.6)',
    },
  },
  [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
    {
      marginLeft: -1,

      borderLeft: '1px solid transparent',
    },
}));

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

export default function EvaSubscribe({ show, closeHandler, reloadHandler, defaultPaymentMethod, currentPlan, availablePlanTypes }) {
  const [
    isProcessing,
    setIsProcessing,
  ] = useState(false);

  const [
    subscriptionStatus,
    setSubscriptionStatus,
  ] = useState('pending');

  const auth = useAuth();

  const [
    clientSecret,
    setClientSecret,
  ] = useState('');

  const [
    sessionExpired,
    setSessionExpired,
  ] = useState(false);

  const [
    outcomeStatus,
    setOutcomeStatus,
  ] = useState();

  const [
    planType,
    setPlanType,
  ] = useState('payg');

  function subscribe() {
    // console.log(availablePlanTypes)

    // return
    const priceId = availablePlanTypes.payg.stripe_price.id;

    setIsProcessing(true);

    fetch(`${window.origin}/api/stripe/session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
      body: JSON.stringify({
        email: auth.user?.profile?.email,
        priceId: priceId,
        subscriptionType: 'individual',
      }),
    }).then((response) => {
      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      }

      return response.json();
    }).then((data) => {
      console.log(data);

      let subscriptionId = data.subscriptionId;

      console.log(subscriptionId);

      setSubscriptionStatus('pending');

      let intervalId = setInterval(() => {
        fetch(`${window.origin}/api/stripe/subscription/${subscriptionId}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth.user?.access_token}`,
          },
        }).then((response) => {
          if (response.status === 403) {
            setSessionExpired(true);
            throw new Error('Session expired');
          }

          return response.json();
        }).then((data) => {
          console.log(data);

          let subStat = data.subscription_status;

          if (subStat != 'pending') {
            setSubscriptionStatus(subStat);
            clearInterval(intervalId);
          }
        });
      }, 100);
    }).catch((error) => {
      setIsProcessing(false);
      setOutcomeStatus('error');
      // setSnackBarMessage('Unknown error occurred, Please try again later')
      // setSnackBarShow(true)
    });
  }

  useEffect(() => {
    if (subscriptionStatus == 'active') {
      reloadHandler();
      setIsProcessing(false);

      setOutcomeStatus(null);
    }
  }, [subscriptionStatus]);

  return (
    <>
      <Modal
        show={show}
        onHide={closeHandler}
        dialogClassName="modal-30w"
        aria-labelledby="example-custom-modal-styling-title"
      >

        <Modal.Body style={{ padding: '2vw 2vw', paddingBottom: '0vw', textAlign: 'center', color: 'rgb(0, 15, 30, 0.8)' }}>
          <h4 style={{ textAlign: 'center', fontSize: '1.3vw', marginBottom: '1vw', fontWeight: '600' }}>Subscription</h4>
          <p style={{ margin: 0, marginBottom: '2vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.7)' }}>Select the payment plan that suits you</p>

          <div style={{ margin: '0.5vw 0vw 1vw 0vw', backgroundColor: 'rgb(254, 254, 255, 0.5)', borderRadius: '1vw', overflow: 'hidden' }}>
            <div style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.2vw', borderTopLeftRadius: '1vw', borderTopRightRadius: '1vw', marginTop: '0', marginBottom: '0' }}>
              <div style={{ fontWeight: '500', fontSize: '0.8vw' }}>
                <p style={{ margin: 0, textAlign: 'left' }}>Plan Type</p>
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ textAlign: 'right', color: 'rgb(0, 15, 30, 0.7)', margin: 0, fontSize: '0.8vw' }}>Pay-as-you-go</p>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.2vw', marginTop: '0', marginBottom: '0', borderTop: '1px solid rgb(0, 0, 0, 0.1)' }}>
              <div style={{ fontWeight: '500', fontSize: '0.8vw' }}>
                <p style={{ margin: 0, textAlign: 'left' }}>Pricing</p>
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ textAlign: 'right', color: 'rgb(0, 15, 30, 0.7)', margin: 0, fontSize: '0.8vw' }}>50 cents per client per year</p>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.2vw', marginTop: '0', marginBottom: '0', borderTop: '1px solid rgb(0, 0, 0, 0.1)' }}>
              <div style={{ fontWeight: '500', fontSize: '0.8vw' }}>
                <p style={{ margin: 0, textAlign: 'left' }}>Contact</p>
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ textAlign: 'right', color: 'rgb(0, 15, 30, 0.7)', margin: 0, fontSize: '0.8vw' }}>{auth.user.profile.preferred_username}</p>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.2vw', borderTop: '1px solid rgb(0, 0, 0, 0.1)', marginTop: '0', marginBottom: '0' }}>
              <div style={{ fontWeight: '500', fontSize: '0.8vw' }}>
                <p style={{ margin: 0, textAlign: 'left' }}>Payment</p>
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ textAlign: 'right', color: 'rgb(0, 15, 30, 0.7)', margin: 0, fontSize: '0.8vw' }}>
                  {String(defaultPaymentMethod?.brand).toUpperCase()}
                  {' '}
                  ****
                  {' '}
                  {String(defaultPaymentMethod?.last4)}
                </p>
              </div>
            </div>

          </div>
          <p style={{ width: '100%', padding: '0.5vw' }}>Automatically renews until cancelled. To stop, tap Cancel Subscription in Settings before next billing date.</p>
          <div style={{ marginBottom: '1vw' }}>

            { !outcomeStatus && !isProcessing && (
              <Button
                onClick={() => { subscribe(availablePlanTypes?.payg?.stripe_price?.id); }}
                disabled={currentPlan?.planType == 'Pay-as-you-go' ? true : false}
                variant="outlined"
                style={{
                  borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                  width: '100%', marginTop: '1vw' }}
              >
                {currentPlan?.planType == 'Pay-as-you-go' ? 'Subscribed' : 'Subscribe'}
              </Button>
            )}

            { outcomeStatus == 'sucess' && !isProcessing && (
              <div style={{ padding: '1vw' }}>
                <CheckCircleOutlineOutlinedIcon style={{ fontSize: '3vw', color: 'green' }} />
              </div>
            )}

            { outcomeStatus == 'error' && !isProcessing && (
              <div style={{ padding: '1vw' }}>
                <CancelOutlinedIcon style={{ fontSize: '3vw', color: 'red' }} />
              </div>
            )}

            { isProcessing && (
              <div style={{ padding: '1vw' }}>
                <CircularProgress style={{ color: 'rgb(28, 108, 108)' }} />
              </div>
            )}

          </div>

        </Modal.Body>
      </Modal>

    </>
  );
}

const selectedStyle = {
  backgroundColor: 'rgba(28, 108, 108, 0.9)',
  color: 'rgb(255, 255, 255, 0.9)',

};

